<template>
    <div>
        <!-- <SuperTree
            v-if = "title"
            :value = "value"
            :title = "title"
            :fieldData = "fieldData"
            :cascaderOptions = "cascaderOptions"
            @on-change = "onChange"
        ></SuperTree> -->
        <Cascader :change-on-select = "changeOnSelect" v-if = "CascaderShow" @on-change = "onChange" :data="cascaderOptions" :placeholder = "title" :value = "value"></Cascader>
        <!-- <SuperCascader @on-change = "onChange" :treeData="cascaderOptions" :value = "value"></SuperCascader> -->
    </div>
</template>

<script>
import { setTimeout } from 'timers';
export default {
    props: {
        value: Array,
        title: String,
        fieldData: Object,
        cascaderOptions: [Array,Object],
        changeOnSelect: Boolean,
    },
    watch: {
        value(){
            this.CascaderShow = false
            this.$nextTick(()=>{
                this.CascaderShow = true
            })
        }
    },
    created(){
        
    },
    data(){
        return {
            CascaderShow: true,
        }
    },
    methods: {
        onChange(e){
            console.log('cascadechange',e)
            // if(e&&e.length){
            //     let id = e[e.length-1]
            //     this.getRelatFields(id)
            // }
            this.$emit('on-change',e)
        }
    }
}
</script>

<style>

</style>